import './index.scss';
import React from 'react';
const Header = ({ children, filteredResults, setSelectedResults, }) => {
    const setFilteredResults = () => {
        setSelectedResults(filteredResults);
    };
    return React.createElement("h5", { className: 'classification-results-header' },
        React.createElement("div", { className: 'header' }, children),
        React.createElement("div", { className: 'action-buttons' },
            React.createElement("div", { className: 'select', onClick: setFilteredResults },
                "Select all",
                React.createElement("div", { className: 'count' },
                    "(",
                    filteredResults.length,
                    ")")),
            React.createElement("div", { className: 'clear', onClick: () => setSelectedResults([]) }, "Clear")));
};
export default Header;
